import React from 'react';

import backgroundImage from '../background.webp';
import cardBackgroundImage from '../cardbackground.webp';
import buttonImage from '../buttonimage.webp';
import mirrorimage from '../mirrorimage.webp';
import { supabase } from '../supabaseClient';
import { toast } from 'react-toastify';

function Affirmations({ goBack, goHome }) {

    const handleSaveProgress = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                toast.error('User not logged in!');
                return;
            }
            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'affirmations',
                    animated_helper: 'no',
                    timestamp: new Date().toISOString(),
                });
            if (progressError) {
                toast.error('Failed to save progress: ' + progressError.message);
                return;
            }
            toast.success('Session progress has been saved successfully!');
        } catch (err) {
            toast.error('An unexpected error occurred while saving progress.');
        }
    };

    return (
        <div
            style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '16px',
            }}
        >
            <h2
                style={{
                    fontFamily: 'Times New Roman',
                    fontSize: '32px',
                    fontWeight: 'bold',
                    color: '#4B5563',
                    margin: '32px 0 24px 0',
                    textAlign: 'center',
                }}
            >
                Affirmations
            </h2>
            {/* Top Card with Image, Title, and Subtitle */}
            <div
                style={{
                    width: '100%',
                    maxWidth: '600px',
                    borderRadius: '10px',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    border: '2px solid black',
                    marginBottom: '24px',
                    overflow: 'hidden',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    textAlign: 'center',
                }}
            >
                <img
                    src={mirrorimage}
                    alt="Mirror"
                    style={{
                        width: '100%',
                        borderRadius: '10px 10px 0 0',
                        objectFit: 'cover',
                        maxHeight: '220px',
                    }}
                />
                <div
                    style={{
                        padding: '24px',
                        background: 'rgba(255,255,255,0.85)',
                        borderBottomLeftRadius: '10px',
                        borderBottomRightRadius: '10px',
                    }}
                >
                    <h2
                        style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '28px',
                            fontWeight: 'normal',
                            textAlign: 'center',
                            color: '#4B5563',
                            margin: '0 0 16px 0',
                        }}
                    >
                        Affirmations
                    </h2>
                    <p
                        style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '16px',
                            color: '#4B5563',
                            margin: 0,
                        }}
                    >
                        Affirmations are positive statements that help you challenge and overcome self-sabotaging and negative thoughts.
                    </p>
                </div>
            </div>
            {/* Session Helper Cards Row */}
            <div
                className="affirmations-session-helper-row"
                style={{
                    display: 'flex',
                    flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                    gap: '16px',
                    width: '100%',
                    maxWidth: '600px',
                    marginBottom: '16px',
                }}
            >
                {/* Left Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                }}>
                    <div style={{ fontFamily: 'Times New Roman', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        • Thinking positively can feel unnatural when we have a habit of thinking the opposite way.<br />
                        • Syncing Hemispeheres of the brain and tapping can help solidify change when using affirmative thinking.<br />
                        • Repetition may be the way we notice an unwanted pattern in ourselves, but it can also be how we program ourselves with something preferred<br />
                        • A powerful way to use affirmations is to start with the statement "I remember when.." and speak as if it had already happened.<br />
                        • When stating an affirmation and you find it does not resonate with you harmoniously it may be better to stop using it. <br />
                        • Using Affirmations is a personal choice.
                    </div>
                </div>
                {/* Right Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <div style={{ fontFamily: 'Times New Roman', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        1. What affirmations do you already use?<br />
                        2. What affirmations have you tried without success?<br />
                        3. Are there looping thoughts in your reality that you will like to experience the opposite of?<br />
                        4. How often are you aware of yourself thinking negatively?<br />
                        5. What is something positive about you that was affirmed for you repeatedly in your life?<br />
                        6. Have you ever tried a night-time recording of positive affirmations?
                    </div>
                </div>
            </div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '24px',
                    width: '100%',
                    maxWidth: '700px',
                    alignItems: 'center',
                }}
            >
                {/* Card 1 */}
                <div
                    style={{
                        width: '100%',
                        maxWidth: '600px',
                        minHeight: '120px',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        borderRadius: '10px',
                        border: '2px solid #4B5563',
                        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                        padding: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        margin: '0 auto',
                    }}
                >
                    <p
                        style={{
                            color: '#4B5563',
                            fontFamily: 'Times New Roman',
                            fontSize: '16px',
                            fontWeight: 'normal',
                            textAlign: 'center',
                            margin: 0,
                        }}
                    >
                        Affirmations are positive statements meant to help you challenge and overcome self-sabotaging and negative thoughts. Some people really respond well to affirmations and some people do not.  Dr. Bruce Lipton teaches that we are programmed by our environment and especially up until the age of 7. He also explains that while in the theta brain wave phase the human is downloading the environment.  Therefore that is a good time to implement affirmations. After age 7 our access to the theta phase happens right before and after sleep.  Repetition is another way humans get programmed; so just listening over and over can be an effective way to reprogram the subconscious.  Another way to use affirmations is in conjunction with Tapping the energy meridians on the body while stating the affirmation.  There is an even faster way to use tapping to help implement change by combining the formula offered on this app while tapping and adding affirmations.   Different things work for different people at different times.  Affirmations are worth adding to your tool box if you find a way that they can work for you. <br /> In my experience, I started my journey by noticing my thoughts were all negatve. At that point I decided to turn my thoughts around and make them positive.  By doing this I learned that both things can be true and I get to decide how to think.  It was not until much later that I learned that the energy responds in the affirmative.  Meaning, whatever I think I get more of.  So even if I am thinking I do not want something.... just thinking about it puts my valuable affirming focus on it, which can cause it to amplify in my experience.  It was the results I got from thinking affirmatively that really showed me how worthwhile it was.  My life got better when I thought it was better.  
                    </p>
                </div>
                {/* Card 2 */}
                <div
                    style={{
                        width: '100%',
                        maxWidth: '600px',
                        minHeight: '120px',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        borderRadius: '10px',
                        border: '2px solid #4B5563',
                        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                        padding: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        margin: '0 auto',
                    }}
                >
                    <p
                        style={{
                            color: '#4B5563',
                            fontFamily: 'Times New Roman',
                            fontSize: '16px',
                            fontWeight: 'normal',
                            textAlign: 'center',
                            margin: 0,
                        }}
                    >
                        The reason affirmations are a valuable tool is because repeating affirmations regularly can help you reprogram your mind and encourage positive changes in your life.  We are living out the programs of our mind and the perspectives that we hold and those beliefs we live out are often hidden from us in our subconsious.  Sometimes we notice that something we believe or a habit we don't want to have anymore is holding us back.  Affirmations can help us make that change for ourselves by changing the rooted belief causing the unwanted experience or habit. 
                    </p>
                </div>
                {/* Card 3 */}
                <div
                    style={{
                        width: '100%',
                        maxWidth: '600px',
                        minHeight: '120px',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        borderRadius: '10px',
                        border: '2px solid #4B5563',
                        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                        padding: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        margin: '0 auto',
                    }}
                >
                    <p
                        style={{
                            color: '#4B5563',
                            fontFamily: 'Times New Roman',
                            fontSize: '16px',
                            fontWeight: 'normal',
                            textAlign: 'center',
                            margin: 0,
                        }}
                    >
                        Repeating something over and over can be really boring and time consuming. You are invited to make this tool your own.  I have used the formula for alleviating looping energy in myself to allow myself to actually feel excited about being me.  It might sound strange but I had never allowed myself to feel excited about being me before that.  It was a very powerful way for me to affirm my own self and the love and devotion that I have for myself. If you are having trouble with an affirmation that does not resonate with you and you feel off everytime you repeat it, perhaps it is an invitation to look deeper within to see what you can learn about yourself regarding that topic.  There might be a misunderstanding that can be easily cleared up when you give yourself the time to dig a little deeper and reflect a little more.  <br /> I am not an expert on the science nor the practical applications of syncing the hemispheres of the body. However, I have been introduced to the concept several times over the years. First it was introduced as a way to turn on Super Learning, later it was explained as a vital step in the process of changing a belief.
                    </p>
                </div>
            </div>
            {/* Navigation Buttons */}
            <div
                className="affirmations-nav-btn-row"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginTop: '56px',
                    marginBottom: '20px',
                }}
            >
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={goBack}
                >
                    Back
                </button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={goHome}
                >
                    Home
                </button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={handleSaveProgress}
                >
                    Save
                </button>
            </div>
            <style>
                {`
                @media (max-width: 600px) {
                    .affirmations-nav-btn-row {
                        /* Remove sticky/fixed positioning for mobile, just keep as a row */
                        position: static !important;
                        width: 100%;
                        background: none;
                        border-top: none;
                        border-radius: 0;
                        box-shadow: none;
                        padding: 0;
                        z-index: auto;
                        display: flex;
                        justify-content: center;
                        gap: 10px;
                        margin-top: 32px !important;
                        margin-bottom: 16px !important;
                    }
                    body {
                        padding-bottom: 0 !important;
                    }
                }
                `}
            </style>
        </div>
    );
}

export default Affirmations;
